export default function skipWaiting() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration()
      .then(registration => {
        const waitingWorker = registration.waiting;
        if (waitingWorker !== null) {
          waitingWorker.postMessage({type: 'SKIP_WAITING'})
        }
      })
  }
}